import type { ParsedQs } from 'qs';

export default (queryObj: ParsedQs, typesenseIndexName: string): ParsedQs => {

  if (queryObj[typesenseIndexName]) {

    const nestedQueryParams = queryObj[typesenseIndexName];
    queryObj = {
      ...(typeof nestedQueryParams === 'object' ? nestedQueryParams : {}),
    } as unknown as ParsedQs;

  }

  if (queryObj.sortBy?.toString().includes(typesenseIndexName)) {

    queryObj.sortBy = queryObj.sortBy.toString()
      .replace(`${typesenseIndexName}-`, '');

  }

  return queryObj;

};
